import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgEventSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 3a.75.75 0 00-1.5 0v1.25H6A2.75 2.75 0 003.25 7v12A2.75 2.75 0 006 21.75h12A2.75 2.75 0 0020.75 19V7A2.75 2.75 0 0018 4.25h-1.25V3a.75.75 0 00-1.5 0v1.25h-6.5V3zm-1.5 2.75h1.5V7a.75.75 0 01-1.5 0V5.75zm12 5.25a.75.75 0 01-.75.75h-13a.75.75 0 010-1.5h13a.75.75 0 01.75.75zm-2.5-5.25h-1.5V7a.75.75 0 001.5 0V5.75zM12 13.25a.75.75 0 01.67.415l.497.991.956.16a.75.75 0 01.407 1.27l-.623.624.169 1.184a.75.75 0 01-1.078.777l-.998-.5-.998.5a.75.75 0 01-1.078-.777l.17-1.184-.624-.624a.75.75 0 01.407-1.27l.956-.16.496-.991A.75.75 0 0112 13.25z",
    fill: "currentColor"
  })));
}

export { SvgEventSolid as ReactComponent };
